// Packages
import "@ckeditor/ckeditor5-build-classic/build/translations/es.js";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import { dom, library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Buefy from "buefy";
import moment from "moment";
import VueScheduler from "v-calendar-scheduler";
import Vue from "vue";
import VueAwesomeSwiper from "vue-awesome-swiper";
import VueChatScroll from "vue-chat-scroll";
import VueGrapesjsComponent from "vue-grapesjs-component";
import VueMoment from "vue-moment";
import VueTour from "vue-tour";
import Vuelidate from "vuelidate";
library.add(fas);
dom.watch();

// App
import VueClipboard from "vue-clipboard2";
import App from "./App.vue";
import { stringSlicer } from "./filters/stringSlicer";
import router from "./router";
import store from "./store";
// Styles
import "swiper/css/swiper.css";
import "v-calendar-scheduler/lib/main.css";
import VueAnalytics from "vue-analytics";
require("@/assets/scss/bulma.scss");
require("@/assets/scss/base.scss");
require("@/assets/scss/breakpoints.scss");
require("@/assets/scss/swiper.scss");
require("@/assets/scss/tutorial.scss");

const analyticsId = process.env.VUE_APP_ID_GOOGLE_ANALITYCS;

if (analyticsId) {
  Vue.use(VueAnalytics, {
    id: analyticsId,
    router,
  });
}

// Vue
moment.locale("es");
Vue.filter("stringSlicer", stringSlicer);
Vue.use(VueAwesomeSwiper);
Vue.config.productionTip = false;
// FontAwesome (fas) es el único icon pack cargado; el default de Buefy
// es Material Design Icons, que no está instalado (iconos en blanco).
Vue.use(Buefy, { defaultIconPack: "fas" });
Vue.use(VueClipboard);
Vue.use(Vuelidate);
Vue.use(VueGrapesjsComponent);
Vue.use(VueMoment, { moment });
Vue.use(VueScheduler, {
  locale: "es",
  minDate: null,
  maxDate: null,
  labels: {
    today: "Hoy",
    back: "Atrás",
    next: "Siguiente",
    month: "Mes",
    week: "Semana",
    day: "Día",
    all_day: "Todo el día",
  },
  timeRange: [8, 20],
  availableViews: ["month"],
  initialDate: new Date(),
  initialView: "week",
  use12: true,
  showTimeMarker: true,
  showTodayButton: false,
  eventDisplay: null,
});
Vue.use(VueChatScroll);
Vue.use(VueTour);
Vue.use(CKEditor);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
